import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { Col, Row, UncontrolledTooltip } from 'reactstrap';
import RatingIcon from '../../../components/RatingIcon';
import './styles.css'

function CardAdminDashboard({
    selected = false,
    place={},
    modeMap=false,
    onClick=() => {},
    onMouseEnter=() => {},
    onMouseLeave=() => {},
    onDeletePlace=() => {},
    onElementInScreen=() => {},
    onOpenPlace=() => {},
    onHidePlace=() => {},
    stateAct=false,
    thumbs,
    btnTrigger=false
}) {
    const { ref, inView } = useInView({
        threshold: 0,
    });
    const { t ,i18n} = useTranslation();
    const{urlImg='',name=t("noName"),nameEn=t("noName"), title='', titleEn = '',/*, descriptionEn= t("noDescription")*/} = place
    useEffect(() => {
        if(modeMap){
            onElementInScreen(place, inView)
        }
        return () => {
            
        }
        //no agregar al hook onElementInScreen
    }, [inView,modeMap,place])

    return (
        <>
        <div className='DashboardActivitie hoverCardAdmin position-relative' >
            <button onClick={onHidePlace} className='hideBtnAdmin'>
            { !thumbs ? <FontAwesomeIcon icon={stateAct ? 'eye-slash': 'eye'}/>:
            <FontAwesomeIcon icon={stateAct ? 'thumbs-down': 'thumbs-up'}/>}
            </button>
            <div id={`carAdmin_${place._id}`} className='position-absolute cursorPointer'  onClick={onOpenPlace} 
            onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}
            style={{
                inset:0,
                zIndex:1
            }}>

            </div>
            <div ref={ref} className={`cardAdminCont ${modeMap &&'cardAdminContOnMap'} `}>
                <div className='cardAdminimg' style={urlImg!=='' ? {backgroundImage: `url(${urlImg})`} : {}}>
                    {urlImg===''&& <div className='noImgCardAdmin'></div> }
                    {/*<button onClick={onOpenPlace} className='btnCardAdmin'>{t("seeActivitie")}</button>*/}
                    {/* <button 
                    onClick={() => {onDeletePlace(place)}}
                    className={`btnCardAdmin d-block d-md-none ${selected && 'btnDelPlace'}`}>{
                        !selected ? <><p className='btnInfo'> {t("addToList")}</p> </>:
                        <><p className='btnInfo'> {t("RemoveFromList")}</p> </>
                    }</button> 
                    
                    <button 
                    onClick={() => {onDeletePlace(place)}}
                    className={`btnCardAdmin d-none d-md-block ${selected && 'btnDelPlace'}`}>{
                        !selected ? <><FontAwesomeIcon icon='plus'></FontAwesomeIcon><span> {t("addToList")}</span> </>:
                        <><FontAwesomeIcon icon='minus'></FontAwesomeIcon><span> {t("RemoveFromList")}</span> </>
                    }</button>
                    */}
                </div>
                <div className='infoAdminCont mt-1'>
                    <h2 className='m-0'>{name}</h2>
                    <p>
                    {title}
                    {/*place.title*/}
                    {/*<br/>
                    <br/>*/}
                    
                    </p>
                    
                    
                    {/*<p>{i18n.language==='es'? descriptionLarge: descriptionEn}</p>*/}
                </div>
            </div>
            <Row className=' justify-content-center align-items-center starsBtnAddCont m-0'>
                        <Col xs='6'>
                        <div className='d-flex ' style={{height:'20px'}}>
                        <h2 className='m-0 d-flex align-items-center' style={{width:'25px', fontSize:'10px'}}>{(parseFloat(place.stars) || 3).toFixed(1)}</h2>
                            {[1, 2, 3, 4, 5].map((index) => {
                                return (
                                <RatingIcon
                                    className=''
                                    width={'10px'}
                                    index={index} 
                                    rating={parseFloat(place.stars) || 3} 
                                    hoverRating={undefined} 
                                    onMouseEnter={() => {}} 
                                    onMouseLeave={() => {}} 
                                    onSaveRating={() => {}} />
                                )
                            })}
                        </div>
                        </Col>
                        <Col style={{zIndex:2}} xs='6' className='d-flex justify-content-end pl-0'>
                        <button 
                        onClick={() => {onDeletePlace(place)}}
                        className={`btnCardAdmin`}>Eliminar</button>
                        </Col>
                    </Row>
        </div>
        </>
    )
}
/*
<Row className='cardAdminCont justify-content-between'>
                <Col className='p-0' xs='2' sm='3' md='3'>
                    <div  className='cardAdminimg' style={urlImg!=='' ? {backgroundImage: `url(${urlImg})`} : {}}>
                </div></Col>
                <Col xs='8' sm='6' md='7' lg='6'  className='infoAdminCont'>
                    <div><h3>{name}</h3></div>
                    <p className='hiddenScroll'>{phrase}
                    </p>
                </Col>
                <Col xs='2' sm='3' md='2' lg='2' className='d-flex flex-column justify-Content-evenly align-items-center pl-0'> 
                
                </Col>
            </Row>
*/
export default React.memo(CardAdminDashboard)
